const SITE_URL = "https://www.reignitespirit.com";

export function createProductSchema({
  id,
  name,
  description,
  image,
  url,
  price,
  currency = "USD",
  availability = "https://schema.org/InStock",
  category = "Career Intelligence Report",
}) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Product",

    "@id": id || `${url}#product`,

    name,
    description,
    image: Array.isArray(image) ? image : [image],
    url,
    category,

    brand: {
      "@type": "Brand",
      name: "ReigniteSpirit",
    },

    manufacturer: {
      "@id": `${SITE_URL}/#organization`,
    },
  };

  if (
    price !== undefined &&
    price !== null &&
    String(price).trim() !== ""
  ) {
    schema.offers = {
      "@type": "Offer",
      url,
      priceCurrency: currency,
      price: String(price),
      availability,
      seller: {
        "@id": `${SITE_URL}/#organization`,
      },
    };
  }

  return schema;
}